/** Locales supportées (v1). */
export type AppLocale = 'fr' | 'en';

export const APP_LOCALES: AppLocale[] = ['fr', 'en'];

export const DEFAULT_APP_LOCALE: AppLocale = 'fr';

export const LOCALE_STORAGE_KEY = 'nauvatek.locale';

export function isAppLocale(value: unknown): value is AppLocale {
  return value === 'fr' || value === 'en';
}
